import { IRootState } from '../../../../store'

export const getSessionPersistSelector = (state: IRootState) => state.sessionPersist
